// extracted by mini-css-extract-plugin
export default {"wrap":"index-module__wrap--2fxzr","authCodeInput":"index-module__authCodeInput--2d9zu","authCodeImg":"index-module__authCodeImg--2DBzy"};